import React from 'react';
import AxiosInstance from '../../helpers/AxiosInstance';
import Swal from 'sweetalert2';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './style.css';
export function useModal(displayOptions, establishmentId) {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const { addButton, editAction, deleteAction } = displayOptions;
  const getContractsByEstablishmentId = (establishmentId, query) =>
    AxiosInstance.get('/contract/by-establishment', { params: { ...query, establishmentId: establishmentId } });
  const getEstablishmentById = (establishmentId) => AxiosInstance.get(`/establishment/${establishmentId}`);
  const attributes = [
    // { name: 'establishment.name', title: t('table.establishment'), nestedObject: [], type: 'text', order: true },
    { name: 'contractStartDate', title: t('table.contractStartDate'), nestedObject: [], type: 'date', order: true },
    { name: 'contractEndDate', title: t('table.contractEndDate'), nestedObject: [], type: 'date', order: true },
    { name: 'status', title: t('table.status'), nestedObject: [], type: 'switcherContract', order: true, active: editAction },
  ];
  const updateContract = (id) => {
    history.push({
      pathname: '/contract/update',
      params: {
        id: id,
      },
    });
  };
  const downloadContractFile = (contract) => {
    history.push({
      pathname: '/invoice',
      params: {
        contract: contract,
      },
    });
  };
  const deleteContract = (id) => {
    Swal.fire({
      title: t('swal.are_you_sure'),
      text: t('swal.delete_permanently'),
      icon: 'warning',

      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('swal.yes_delete'),
      cancelButtonText: t('swal.no'),
    }).then((result) => {
      if (result.isConfirmed) {
        AxiosInstance.delete('/contract/' + id)
          .then((response) => {
            Swal.fire(t('contract.SUCCESS_DELETE_CONTRACT'), '', 'success');
            history.push('/contract');
            getContractsByEstablishmentId(establishmentId);
          })
          .catch((error) => {
            Swal.fire(t('contract.ERROR_DELETE_CONTRACT'), '', 'error');
          });
      }
    });
  };
  const actions = {
    delete: deleteAction && deleteContract,
    update: editAction && updateContract,
    downloadContractFile: downloadContractFile,
  };

  return {
    attributes,
    actions,
    getContractsByEstablishmentId,
    getEstablishmentById,
  };
}
